import { render, staticRenderFns } from "./BonusTitle.vue?vue&type=template&id=7256bc7c&scoped=true"
import script from "./BonusTitle.vue?vue&type=script&lang=js"
export * from "./BonusTitle.vue?vue&type=script&lang=js"
import style0 from "./BonusTitle.vue?vue&type=style&index=0&id=7256bc7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7256bc7c",
  null
  
)

export default component.exports